/**
 * The selector is required for cases where we need to apply skipToken,
 * but the data can contain a previous response instead of an empty array or undefined.
 */
export const mapDataToUndefinedIfSkip = <
  T extends { data?: unknown; isUninitialized?: boolean },
>(
  result: T,
): T => (result.isUninitialized ? { ...result, data: undefined } : result);
